// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import './styles/global.css'; // Keep your global styles import
import './styles/layout.css';

import App from './App';

if (window.history.scrollRestoration) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);